export default "__VITE_ASSET__lx0gPHu7__"